import React, { useState, useEffect, forwardRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from "@material-ui/core/Tooltip";
import * as moment from "moment";
import { useRecoilState } from 'recoil';

import { VehicleHistoryDateState } from '../../store/VehicleHistoryDateStore';



const HistoryDate = (props) => {
  const { isMobile } = props;
  const [isDisbleForward, setisDisbleForward] = useState(true);
  const ref = React.createRef();

  const [vehicleHistoryDate, setVehicleHistoryDate] = useRecoilState(VehicleHistoryDateState);

  const addDate = (days) => {
    // let changeDate = moment(startDate).format();
    // changeDate.setDate(changeDate.getDate() + days);
    // setDate(changeDate);
    setVehicleHistoryDate(moment(vehicleHistoryDate).add(days, "days").format("YYYY-MM-DD"));
  };

  useEffect(() => {
    if (moment(vehicleHistoryDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) {
      setisDisbleForward(false);
    }
    else {
      setisDisbleForward(true);
    }
  }, [vehicleHistoryDate]);

  const CustomerDateInput = forwardRef(function getDateInput({ value, onClick }, ref) {
    return (<button style={{ width: 110 }} className="btn btn-outline-primary btn-sm" onClick={onClick} ref={ref}>
      {value}
    </button>);
  });

  useEffect(() => {

    return (() => {
      setVehicleHistoryDate(null);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  if (!vehicleHistoryDate) {
    return "";
  }

  return (
    <div className="row no-gutters">
      <Tooltip title="Prev" aria-label="Prev">
        <IconButton
          onClick={() => addDate(-1)}
          style={{ padding: "12px 2px 12px 22px" }}
          aria-label="Before"
        >
          <NavigateBeforeIcon />
        </IconButton>
      </Tooltip>

      <DatePicker
        dateFormat="dd/MM/yyyy"
        selected={new Date(moment(vehicleHistoryDate).format())}
        onChange={(date) => setVehicleHistoryDate(date)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className="form-control"
        //calendarContainer={MyContainer}
        withPortal={isMobile}
        customInput={<CustomerDateInput ref={ref} />}
      />
      <Tooltip title="Next" aria-label="Next">
        <span>
          <IconButton
            disabled={isDisbleForward}
            onClick={() => addDate(1)}
            style={{ padding: "12px 22px 12px 2px" }}
            aria-label="Next"
          >
            <NavigateNextIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

export default HistoryDate;
